import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { AgrNotificationEmptyModule, AgrPageToolbarModule } from '@next/core-lib/components';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { FertilitySummaryComponent } from './components/fertility-summary/fertility-summary.component';
import { IndividualFertilityComponent } from './components/individual-fertility/individual-fertility.component';
import { FertilityEffects } from './store/effects/fertility-effects';
import { fertilityReducer } from './store/reducers/fertility-reducers';

@NgModule({
  imports: [
    AgrTableModule,
    AgrPageToolbarModule,
    AgrNotificationEmptyModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    CommonModule,
    SharedModule,
    IndividualFertilityComponent,
    FertilitySummaryComponent,
  ],
  providers: [provideState('fertility', fertilityReducer), provideEffects([FertilityEffects])],
})
export class FertilityModule {}
